import React from 'react';
import BaseAlert, {
    AlertTypes,
    AlertId
} from 'components/common/alerts/BaseAlert';
import { useTranslation } from 'react-i18next';
import { useLocaleFormatter } from 'components/hooks/useLocaleFormatter';
import BankDetailsInfo from '../BankDetailsInfo';
import { formatCurrency } from 'helpers/currency';

const MissedPaymentInfo = ({
    missedPayments,
    bankDetails,
    className
}: {
    missedPayments: Array<{
        amount: number;
        date: string;
        currency?: string;
    }>;
    bankDetails?: {
        accountHolderName?: string;
        accountNumber?: string;
        sortCode?: string;
    };
    className?: string;
}) => {
    const { t } = useTranslation();

    const { toLocalDate } = useLocaleFormatter();

    return (
        <div>
            <BaseAlert
                alertType={AlertTypes[AlertId.Info]}
                includeImage
                message={t('missed_payment.advisory_message')}
            />
            <div className={`card ${className ?? ''}`}>
                <div className='card-body'>
                    <h4 className='fw-bold mb-3'>
                        {t('missed_payment.details_header')}
                    </h4>
                    <div className='row mb-2 border-bottom pb-2 px-1 fw-bold'>
                        <div className='col-6'>{t('missed_payment.date')}</div>
                        <div className='col-6 text-end'>
                            {t('missed_payment.amount_due')}
                        </div>
                    </div>
                    {missedPayments.map((missedPayment, index) => (
                        <div
                            className='row mb-2 border-bottom py-2 px-1'
                            key={`missed-payment-${index.toString()}-${missedPayment.date}`}>
                            <div className='col-6'>
                                {missedPayment.date
                                    ? toLocalDate(missedPayment.date)
                                    : '-'}
                            </div>
                            <div className='col-6 text-end'>
                                {formatCurrency(
                                    missedPayment.amount,
                                    missedPayment.currency ?? ''
                                )}
                            </div>
                        </div>
                    ))}
                    <div className='row mb-5' />
                    <BankDetailsInfo
                        title={t('direct_debit_bank_details')}
                        accountName={bankDetails?.accountHolderName}
                        accountNumber={bankDetails?.accountNumber}
                        sortCode={bankDetails?.sortCode}
                        className='mb-3'
                    />
                </div>
            </div>
        </div>
    );
};

export default MissedPaymentInfo;
